import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { buildWorkspacePath } from "../../core";
import { useBootstrap, useMe } from "../queries/useBoot";
import { useT } from "../providers/LocaleProvider";
import { firstAppAction } from "../../managers/workspace-utils";

// Resolves /wc → /wc/{activeOrgCode}/{firstApp's first action}/{its default view}.
export function WorkspaceEntry() {
    const me = useMe();
    const boot = useBootstrap();
    const navigate = useNavigate();
    const t = useT();

    useEffect(() => {
        const identity = me.data;
        const bootData = boot.data;
        if (!identity || !bootData) return;
        const org =
            identity.allowedOrganizations.find((o) => o.id === identity.activeOrganizationId) ??
            identity.allowedOrganizations[0];
        const code = org?.code ?? "_";
        const action = firstAppAction(bootData);
        const path = action
            ? buildWorkspacePath(code, [{ kind: "action", actionKey: action.actionKey, viewMode: action.viewMode }])
            : `/wc/${code}/home/list`;
        navigate({ to: path, replace: true } as Parameters<typeof navigate>[0]);
    }, [me.data, boot.data, navigate]);

    const message = me.isError || boot.isError ? t("workspace.error") : t("workspace.loading");
    return <div className="flex min-h-screen items-center justify-center font-sans">{message}</div>;
}
